import { apiClient } from '@/lib/apiClient';
import type {
  SupportListResponse,
  SupportPriority,
  SupportRequestStatus,
  SupportRequestType,
  SupportStats,
  SupportTicket,
} from '../types';

export interface ListSupportParams {
  limit?: number;
  cursor?: string;
  status?: SupportRequestStatus;
  type?: SupportRequestType;
  priority?: SupportPriority;
}

export interface UpdateStatusBody {
  status: SupportRequestStatus;
  adminNote?: string;
}

export const supportApi = {
  list: (params: ListSupportParams = {}) =>
    apiClient.get<SupportListResponse>('/support', { ...params }),

  stats: () => apiClient.get<SupportStats>('/support/stats'),

  listSafety: (params: { limit?: number; cursor?: string } = {}) =>
    apiClient.get<SupportListResponse>('/support/safety', { ...params }),

  detail: (ticketId: string) =>
    apiClient.get<SupportTicket>(`/support/${encodeURIComponent(ticketId)}`),

  updateStatus: (ticketId: string, body: UpdateStatusBody) =>
    apiClient.put<null>(
      `/support/${encodeURIComponent(ticketId)}/status`,
      body,
    ),
};
